/**
 * Billing helpers for Preventive Maintenance forms.
 * A billable PM form is a unit with a PM configuration (service matrix).
 */

export type PmBillingConfigRef = {
    id?: string | null;
    unitId?: string | null;
};

/**
 * Count billable PM forms for a company.
 * One form per unit that has a PM configuration. Duplicate configs on the same unit count once.
 */
export function countPmFormsForBilling(configs: PmBillingConfigRef[] | null | undefined): number {
    if (!configs?.length) return 0;
    const unitIds = new Set<string>();
    for (const config of configs) {
        const unitId = config.unitId?.trim();
        if (unitId) {
            unitIds.add(unitId);
            continue;
        }
        // Rare rows without unitId still bill if they have an id.
        if (config.id?.trim()) unitIds.add(`config:${config.id.trim()}`);
    }
    return unitIds.size;
}
